import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "pb-12"
};
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { ColorEnum, IconEnum } from "@/modules/vue/enums";
import Icon from "@/modules/vue/components/Icon.vue";
import { generateColorMap } from "@/modules/vue/utils";
export default /*#__PURE__*/_defineComponent({
  __name: 'ActionLayout',
  props: {
    actionIcon: {
      default: IconEnum.PlayCircle
    },
    actionColor: {
      default: ColorEnum.Slate
    },
    actionDisabled: {
      type: Boolean
    },
    position: null
  },
  emits: ['click-action'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const classes = computed(() => ({
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end'
    })[props.position]);
    const actionColorMap = generateColorMap({
      text: 500
    });
    const onClickAction = event => {
      if (props.actionDisabled) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return;
      }
      emit('click-action');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, null, _createSlots({
        footer: _withCtx(() => [__props.actionIcon ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["relative flex h-20 px-4", _unref(classes)])
        }, [__props.position !== 'center' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["grow", {
            'mr-4': __props.position === 'end',
            'ml-4 order-2': __props.position === 'start'
          }])
        }, [_renderSlot(_ctx.$slots, "actionPanel")], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
          class: _normalizeClass(["cursor-pointer -translate-y-1/2 rounded-full flex items-center justify-center h-32 w-32 mt-4", {
            [_unref(actionColorMap)[__props.actionColor]]: true,
            'opacity-50': __props.actionDisabled
          }]),
          onClick: onClickAction
        }, [_createVNode(Icon, {
          size: "6rem",
          icon: __props.actionIcon
        }, null, 8, ["icon"])], 2)], 2)) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")])]),
        _: 2
      }, [_ctx.$slots.title ? {
        name: "title",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "title")])
      } : undefined, _ctx.$slots.subtitle ? {
        name: "subtitle",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "subtitle")])
      } : undefined]), 1024);
    };
  }
});